import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './Badge.module.css';

export enum BadgeColor {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  INFO = 'info',
  LIGHT_BLUE = 'lightBlue',
  NOTICE = 'notice',
  ERROR = 'error',
  WHITE = 'white',
}

type BadgeVariant = 'solid' | 'subtle';

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md';
  color?: BadgeColor;
  variant?: BadgeVariant;
}

/**
 * See Figma: https://www.figma.com/design/OuKG28K37tcn264V957VTU/Design-System?node-id=764-7448
 */
export const Badge = ({
  children,
  size = 'md',
  color = BadgeColor.DEFAULT,
  variant = 'solid',
  className,
  ...rest
}: BadgeProps) => {
  if (size === 'sm' && children) {
    console.warn(
      'Small badges are used as an indicator and should not have children.'
    );
  }

  return (
    <div
      className={classNames(
        styles.badge,
        styles[size],
        styles[variant],
        styles[color],
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
